// extracted by mini-css-extract-plugin
export default {"Sidebar":"styles_Sidebar__gyQOg","show":"styles_show__eRPZY","navigationMenu":"styles_navigationMenu__MW1vv","link":"styles_link__lZbt9","active":"styles_active__2E+31"};